import { useTranslation } from 'react-i18next';

import Hello from '@public/images/reactions/hello.svg';
import Clap from '@public/images/reactions/clap.svg';
import Thumbsup from '@public/images/reactions/agree.svg';
import Victory from '@public/images/reactions/victory.svg';
import Waving from '@public/images/reactions/wave.svg';
import Twist from '@public/images/reactions/dance.svg';
import Disagree from '@public/images/reactions/disagree.svg';
import RaiseHand from '@public/images/reactions/raisehand.svg';
import LowerHand from '@public/images/reactions/lowerhand.svg';

import { REACTIONS } from '@constants/reactions';
import { IReactionType } from '../interfaces';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { ExperienceFeatures } from '@interfaces/event';
import { isEventFeatureEnabled } from '@helpers/events';
import { useMemo } from 'react';

export const useReactions = () => {
  const { t: translate } = useTranslation();
  const { currentEvent } = useMytaverseEvent();
  const reactions: IReactionType[] = [];

  // The RAISE_HAND experience flag is the gate UE5 reads too; the legacy `Q`
  // disabled-key list stays honoured for experiences still configured that way.
  const isRaiseHandDisabled = useMemo(
    () =>
      !isEventFeatureEnabled(currentEvent, ExperienceFeatures.RaiseHand) ||
      !!currentEvent?.disabledKeyCommands?.some(
        (key) => key.toLowerCase() === String('Q').toLowerCase(),
      ),
    [currentEvent],
  );

  for (let i = 0; i < REACTIONS.length; i++) {
    switch (REACTIONS[i]) {
      case 'waving':
        reactions.push({
          previewImage: Hello,
          id: 'waving',
          title: translate('actions.hello'),
        });
        break;
      case 'clap':
        reactions.push({
          previewImage: Clap,
          id: 'clap',
          title: translate('actions.clap'),
        });
        break;
      case 'waving2':
        reactions.push({
          previewImage: Waving,
          id: 'waving2',
          title: translate('actions.waving'),
        });
        break;
      case 'cooldance':
        reactions.push({
          previewImage: Twist,
          id: 'cooldance',
          title: translate('actions.dance'),
        });
        break;
      case 'agreeing':
        reactions.push({
          previewImage: Thumbsup,
          id: 'agreeing',
          title: translate('actions.agree'),
        });
        break;
      case 'victory':
        reactions.push({
          previewImage: Victory,
          id: 'victory',
          title: translate('actions.victory'),
        });
        break;
      case 'thumbsdown':
        reactions.push({
          previewImage: Disagree,
          id: 'thumbsdown',
          title: translate('actions.thumbsdown'),
        });
        break;
      case 'raisehand':
        if (isRaiseHandDisabled) {
          break;
        }

        reactions.push({
          activeImage: RaiseHand,
          inactiveImage: LowerHand,
          id: 'raisehand',
          title: translate('actions.raisehand'),
          type: 'toggle',
        });

        break;
    }
  }

  return reactions;
};
